import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import commonENGB from "../locales/en-GB/common_en-GB.json";
import commonNLNL from "../locales/nl-NL/common_nl-NL.json";
import commonDEDE from "../locales/de-DE/common_de-DE.json";
import commonFRFR from "../locales/fr-FR/common_fr-FR.json";
import commonPTPT from "../locales/pt-PT/common_pt-PT.json";
import commonITIT from "../locales/it-IT/common_it-IT.json";
import commonESES from "../locales/es-ES/common_es-ES.json";
import {
  DEFAULT_LOCALE,
  resolveLocaleFallbacks,
  SUPPORTED_LOCALES,
} from "./utils/i18nLocales";

i18n.use(initReactI18next).init({
  resources: {
    "en-GB": {
      common: commonENGB,
    },
    "nl-NL": {
      common: commonNLNL,
    },
    "de-DE": {
      common: commonDEDE,
    },
    "fr-FR": {
      common: commonFRFR,
    },
    "pt-PT": {
      common: commonPTPT,
    },
    "it-IT": {
      common: commonITIT,
    },
    "es-ES": {
      common: commonESES,
    },
  },
  supportedLngs: [...SUPPORTED_LOCALES],
  lng: DEFAULT_LOCALE,
  fallbackLng: (code) => resolveLocaleFallbacks(code),
  ns: ["common"],
  defaultNS: "common",
  interpolation: { escapeValue: false },
});

export default i18n;
